// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","projects-title":"Projects_projects-title__2obqN","projects-list":"Projects_projects-list__hy+iW"};